import React, {Component} from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'

import Title from 'components/Title'
import Subtitle from 'components/Subtitle'
import registerIdHelper from '@rambler-id/utils/es/registerIdHelper'

import styles from './styles.module.css'

class Proposal extends Component {
  componentDidMount = async () => {
    const helper = await registerIdHelper()

    helper.openAuth({
      container: this.proposal,
      path: '/login-20/phone-login',
      registration_link: '/login-20/phone-login'
    })
  }

  render() {
    return (
      <section id="proposal" className={styles.proposal}>
        <article className={styles.info}>
          <Title level={2} type="proposal">
            <span className={styles.deskPadding}>
              <span className={styles.mobPadding}>Присоединяйтесь</span> к нам,
              чтобы
            </span>{' '}
            пользоваться всеми{' '}
            <span className={styles.desktop}>персональными</span> сервисами
          </Title>
          <Subtitle type="proposal">
            Cоздайте ящик на Рамблер/почте, используйте другую почту или
            подключайтесь через социальные сети для создания профиля.
          </Subtitle>
        </article>
        <div ref={(elem) => (this.proposal = elem)} className={styles.frame} />
      </section>
    )
  }
}

export default withStyles(styles)(Proposal)
